import { createFileRoute } from "@tanstack/react-router";
import { ProductDeviceDetail } from "./-components/ProductDeviceDetail";

export const Route = createFileRoute(
  "/_staff/marketplace/_store/store/devices/$productId/",
)({
  component: ProductDeviceDetail,
});
